import { Translate } from '../../../../shared/LanguageService';
import { NavItem, Dropdown } from 'react-bootstrap';
import * as React from 'react';
import * as Features from '../../../../shared/Features';
import ImpersonateButton from '../../../../components/ImpersonateButton';
import AgentModal from '../../../../features/brokers/agent/AgentModal';
import FirmModal from '../../../../features/brokers/firm/FirmModal';

interface IBrokerFirmWithDropDown {
    user: any;
    name: string;
    brokerTreeNodeId: number;
    navigateTo: (path: string) => void;
}

interface IBrokerAgentWithDropDown {
    user: any;
    name: string;
    id: number;
    brokerTreeNodeId: number;
    navigateTo: (path: string) => void;
}

export class BrokerFirmWithDropDown extends React.Component<IBrokerFirmWithDropDown, any> {
    constructor(props: IBrokerFirmWithDropDown, context: any) {
        super(props, context);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div>
                {Features.hasFeature(Features.UpdateBrokerTreeNode, this.props.user) && (
                    <Dropdown id="firm-dropdown" style={{marginBottom: '7px'}}>
                        <Dropdown.Toggle>
                            <i className="material-icons">location_city</i> {this.props.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <NavItem onClick={() => this.setState({ showModal: true })}>
                                <i className="material-icons">edit</i> Redigera
                            </NavItem>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                {!Features.hasFeature(Features.UpdateBrokerTreeNode, this.props.user) && (
                    <span>
                        <i className="material-icons">location_city</i> {this.props.name}
                    </span>
                )}
                {this.state.showModal && (
                    <FirmModal
                        onClose={() => this.setState({ showModal: false })}
                        item={{ id: this.props.brokerTreeNodeId }}
                    />
                )}
            </div>
        );
    }
}

export class BrokerAgentWithDropDown extends React.Component<IBrokerAgentWithDropDown, any> {
    constructor(props: IBrokerAgentWithDropDown, context: any) {
        super(props, context);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div>
                {Features.hasAnyFeature(
                    [Features.Impersonation, Features.UpdateBrokerTreeNode],
                    this.props.user
                ) && (
                    <Dropdown id="agent-dropdown" style={{marginBottom: '7px'}}>
                        <Dropdown.Toggle>
                            <i className="material-icons">face</i> {this.props.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {Features.hasFeature(Features.Impersonation, this.props.user) && (
                                <ImpersonateButton
                                    userId={this.props.id}
                                    type="MenuItem"
                                    skipRedirect
                                />
                            )}
                            {Features.hasFeature(
                                Features.UpdateBrokerTreeNode,
                                this.props.user
                            ) && (
                                <NavItem onClick={() => this.setState({ showModal: true })}>
                                    <i className="material-icons">edit</i>
                                        {Translate('orders/view/common/dropdown/edit')}
                                </NavItem>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                {!Features.hasAnyFeature(
                    [Features.Impersonation, Features.UpdateBrokerTreeNode],
                    this.props.user
                ) && (
                    <span>
                        <i className="material-icons">face</i> {this.props.name}
                    </span>
                )}
                {this.state.showModal && (
                    <AgentModal
                        onClose={() => this.setState({ showModal: false })}
                        item={{ id: this.props.brokerTreeNodeId }}
                    />
                )}
            </div>
        );
    }
}
